import { AccessComponent } from './access.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainEmailComponent } from './main-email/main-email.component';
import { ReportComponent } from './report/report.component';
import { MainAppComponent } from './main-app/main-app.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GeneralComponent } from './general/general.component';
import { BasesConocimientoComponent } from './bases-conocimiento/bases-conocmiento.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
	declarations: [
		AccessComponent,
		MainEmailComponent,
		ReportComponent,
		BasesConocimientoComponent,
		MainAppComponent,
		GeneralComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		NgbModule,
		SharedModule
	],
	exports: [
		AccessComponent
	]
})
export class AccessModule {
}
